var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('surveys-table',{attrs:{"surveyName":"RIESGO ASOCIADO","surveyCode":"RIE_ASO","permission":{
      createSurvey: _vm.permissions.CREATE_SURVEY_ASSOCIATED_RISK,
      viewDetail: _vm.permissions.SEE_DETAIL_SURVEY_ASSOCIATED_RISK,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }